import { onDomReady, querySelectorAll } from '../utils/dom';

const lazyJsAttribute = 'data-js-lazy';
const loadedScripts = new Set<string>();

// eslint-disable-next-line import/prefer-default-export
export function loadScriptFromElement(element: HTMLElement, srcAttribute = lazyJsAttribute): void {
    const src = element.getAttribute(srcAttribute);

    if (!src) {
        return;
    }

    if (loadedScripts.has(src)) {
        element.removeAttribute(srcAttribute);
        return;
    }

    const existingScript = document.querySelector(`script[src="${src}"]`);

    if (existingScript) {
        loadedScripts.add(src);
        element.removeAttribute(srcAttribute);

        return;
    }

    const script = document.createElement('script');

    script.src = src;
    script.type = 'text/javascript';
    script.async = true;

    loadedScripts.add(src);

    document.querySelector('body')?.append(script);

    element.removeAttribute(srcAttribute);
}

function createObserver(): IntersectionObserver {
    const lazyJsObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const element = entry.target as HTMLElement;

                loadScriptFromElement(element);
                lazyJsObserver.unobserve(element);
            }
        });
    });

    return lazyJsObserver;
}

function searchForLazyScriptsElements(initHandler: (el: HTMLElement) => void): void {
    const lazyJs = querySelectorAll(`[${lazyJsAttribute}]`);

    lazyJs.forEach(initHandler);
}

onDomReady(() => {
    if ('IntersectionObserver' in window) {
        const lazyJsObserver = createObserver();

        searchForLazyScriptsElements((el) => lazyJsObserver.observe(el));
    } else {
        searchForLazyScriptsElements(loadScriptFromElement);
    }
});
